import encodeChartConfigToBase64 from "./encoder";

const createCopy = (object) => JSON.parse(JSON.stringify(object));

/**
 * @param {object | Array<object>} echartOption Opções de configuração do echarts para cada gráfico, note que
 * echartOptions pode ser um array de objetos porque em algumas situações mais de um gráfico pode ser renderizado
 * por card.
 * @param {string} chartType Tipo do gráfico - BAR | PIE | FUNNEL | LINE ...
 * @param {object} filters Filtros definidos pelo usuário
 */
export default function getProcessedEchartOption(echartOption, chartType, cardType, enunciados, filters) {
  // Não queremos afetar o objeto real de opções do gráfico.
  const echartOptionCopy = Array.isArray(echartOption)
    ? createCopy(echartOption) : [createCopy(echartOption)];

  const isArrayOfQuestionLabels = Array.isArray(enunciados)
    && enunciados.filter((enunciado) => Array.isArray(enunciado)).length === enunciados.length;

  const chartOptionsSchema = echartOptionCopy.map((echartOptionObject, index) => ({
    chartOptions: echartOptionObject,
    enunciado: (isArrayOfQuestionLabels && enunciados[index]) || enunciados,
  }));

  const payloadSchema = {
    filters: createCopy(filters),
    cardType,
    chartType,
    charts: chartOptionsSchema,
  };

  // Retorna os dados comprimidos e encodados em base64
  return encodeChartConfigToBase64(payloadSchema);
}
